<header>
  <title>{{nombre}}</title>
</header>
<router-outlet></router-outlet>

<modal-open-point id="modal-no-implemented">
  <div normal>
    <modal-no-implemented></modal-no-implemented>
  </div>
</modal-open-point>

<modal-open-point id="modal-terminos-condiciones">
  <div normal>
    <modal-terminos-condiciones></modal-terminos-condiciones>
  </div>
</modal-open-point>

<modal-open-point id="modal-data-empresa">
  <div normal class="bubletext">
    <modal-data-empresa></modal-data-empresa>
  </div>
</modal-open-point>

<modal-open-point id="modal-info-prov">
  <div normal class="bubletext">
    <modal-info-prov></modal-info-prov>
  </div>
</modal-open-point>

<modal-open-point id="modal-work-withAs">
  <div normal class="bubletext">
    <modal-work-withAs></modal-work-withAs>
  </div>
</modal-open-point>

<modal-newsletter></modal-newsletter>

<whatsapp-flotante></whatsapp-flotante>